/**
 * The `viewport.*` color tokens a color prop can bind to. Every theme defines
 * the same keys (enforced by the theme schema and parity tests), so the first
 * theme's keys are the list.
 */
import { THEMES } from "../../themes";

export function viewportColorTokens(): readonly string[] {
  const viewport = THEMES[0]?.viewport ?? {};
  return Object.entries(viewport)
    .filter(([, value]) => typeof value === "string")
    .map(([key]) => key);
}
